var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"mx-auto",staticStyle:{"max-width":"860px","min-height":"200px"}},[_c('img',{staticStyle:{"max-width":"100%"},attrs:{"src":require("@/assets/images/schema-cycle-meeting.jpg")}})])
}]

export { render, staticRenderFns }